<aside class="side-nav" [class.open]="isOpen">
  <div class="nav-brand">
    <div class="logo-icon">
      <i class="bi bi-box-seam-fill"></i>
    </div>
    <div class="brand-text">
      <span class="logo-text">IMS</span>
      <span class="logo-sub">Inventory Management System</span>
    </div>
    <button type="button" class="nav-close-btn" (click)="close()" aria-label="Close navigation">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <nav class="nav-menu" (click)="onNavLinkClick($event)">
    <div class="nav-section">
      <span class="nav-label">Inventory</span>
      <a routerLink="/dashboard" routerLinkActive="active" class="nav-link">
        <i class="bi bi-grid-1x2-fill"></i>
        <span>Dashboard</span>
      </a>
    </div>

    @if (canSee('inventory')) {
      <div class="nav-section">
        <a routerLink="/item-master" routerLinkActive="active" class="nav-link">
          <i class="bi bi-list-ul"></i>
          <span>Register Items</span>
        </a>
        <a routerLink="/current-stock" routerLinkActive="active" class="nav-link">
          <i class="bi bi-boxes"></i>
          <span>Current Stock</span>
        </a>
        <a routerLink="/goods-received" routerLinkActive="active" class="nav-link">
          <i class="bi bi-truck"></i>
          <span>Goods Received</span>
        </a>
        <a routerLink="/issue-stock" routerLinkActive="active" class="nav-link">
          <i class="bi bi-box-arrow-up"></i>
          <span>Issue Stock</span>
        </a>
        <a routerLink="/issued-stock" routerLinkActive="active" class="nav-link">
          <i class="bi bi-journal-text"></i>
          <span>Issued Stock</span>
        </a>
        <a routerLink="/item-history" routerLinkActive="active" class="nav-link">
          <i class="bi bi-geo-alt"></i>
          <span>Track Item</span>
        </a>
        <a routerLink="/stock-transfers" routerLinkActive="active" class="nav-link">
          <i class="bi bi-arrow-left-right"></i>
          <span>Stock Transfers</span>
        </a>
      </div>
    }

    @if (canSee('rental')) {
      <div class="nav-section">
        <span class="nav-label">Equipment Rental</span>
        <a routerLink="/reservations" routerLinkActive="active" class="nav-link">
          <i class="bi bi-calendar-event"></i>
          <span>Reservations</span>
        </a>
        <a routerLink="/check-out" routerLinkActive="active" class="nav-link">
          <i class="bi bi-box-arrow-right"></i>
          <span>Issue Equipment</span>
        </a>
        <a routerLink="/check-in" routerLinkActive="active" class="nav-link">
          <i class="bi bi-arrow-return-left"></i>
          <span>Check-In / Returns</span>
        </a>
        <a routerLink="/damaged-lost" routerLinkActive="active" class="nav-link">
          <i class="bi bi-exclamation-triangle"></i>
          <span>Damaged / Lost</span>
        </a>
      </div>
    }

    @if (canSee('maintenance')) {
      <div class="nav-section">
        <span class="nav-label">Maintenance</span>
        <a routerLink="/maintenance-jobs" routerLinkActive="active" class="nav-link">
          <i class="bi bi-wrench"></i>
          <span>Maintenance Jobs</span>
        </a>
        <a routerLink="/repair-history" routerLinkActive="active" class="nav-link">
          <i class="bi bi-clock"></i>
          <span>Repair History</span>
        </a>
      </div>
    }

    @if (canSee('reports')) {
      <div class="nav-section">
        <span class="nav-label">Reports</span>
        <a routerLink="/reports" routerLinkActive="active" class="nav-link">
          <i class="bi bi-bar-chart"></i>
          <span>All Reports</span>
        </a>
        <a routerLink="/stock-on-hand" routerLinkActive="active" class="nav-link">
          <i class="bi bi-file-earmark-bar-graph"></i>
          <span>Stock on Hand</span>
        </a>
        <a routerLink="/low-stock" routerLinkActive="active" class="nav-link">
          <i class="bi bi-exclamation-triangle"></i>
          <span>Low Stock</span>
        </a>
        <a routerLink="/stock-movement" routerLinkActive="active" class="nav-link">
          <i class="bi bi-arrow-left-right"></i>
          <span>Stock Movement</span>
        </a>
        <a routerLink="/case-usage" routerLinkActive="active" class="nav-link">
          <i class="bi bi-calendar3"></i>
          <span>Case / Job Usage</span>
        </a>
        <a routerLink="/checked-out-equipment" routerLinkActive="active" class="nav-link">
          <i class="bi bi-tools"></i>
          <span>Checked-Out Equipment</span>
        </a>
        <a routerLink="/overdue-returns-report" routerLinkActive="active" class="nav-link">
          <i class="bi bi-clock-history"></i>
          <span>Overdue Returns</span>
        </a>
        <a routerLink="/damaged-equipment" routerLinkActive="active" class="nav-link">
          <i class="bi bi-exclamation-circle"></i>
          <span>Damaged Equipment</span>
        </a>
        <a routerLink="/stock-valuation" routerLinkActive="active" class="nav-link">
          <i class="bi bi-coin"></i>
          <span>Stock Valuation</span>
        </a>
      </div>
    }

    @if (canSee('settings') || canSee('users')) {
      <div class="nav-section">
        <span class="nav-label">Settings</span>
        @if (canSee('settings')) {
          <a routerLink="/branches" routerLinkActive="active" class="nav-link">
            <i class="bi bi-building"></i>
            <span>Branches</span>
          </a>
          <a routerLink="/locations" routerLinkActive="active" class="nav-link">
            <i class="bi bi-geo-alt"></i>
            <span>Locations</span>
          </a>
          <a routerLink="/categories" routerLinkActive="active" class="nav-link">
            <i class="bi bi-tags"></i>
            <span>Categories</span>
          </a>
          <a routerLink="/units-of-measure" routerLinkActive="active" class="nav-link">
            <i class="bi bi-rulers"></i>
            <span>Units of Measure</span>
          </a>
          <a routerLink="/suppliers" routerLinkActive="active" class="nav-link">
            <i class="bi bi-building"></i>
            <span>Suppliers</span>
          </a>
        }
        @if (canSee('users')) {
          <a routerLink="/user-permissions" routerLinkActive="active" class="nav-link">
            <i class="bi bi-shield-lock"></i>
            <span>User Permissions</span>
          </a>
        }
      </div>
    }
  </nav>

  <div class="nav-footer">
    <div class="user-profile">
      <div class="avatar">{{ userInitials }}</div>
      <div class="user-info">
        <div class="user-name">{{ userName }}</div>
        <div class="user-role">{{ userRole }}</div>
        <div class="user-company" [title]="companyName">
          <i class="bi bi-buildings"></i>
          <span>{{ companyName }}</span>
        </div>
      </div>
      <button type="button" class="logout-btn" (click)="logout()" aria-label="Sign out">
        <i class="bi bi-box-arrow-right"></i>
      </button>
    </div>
  </div>
</aside>

